import scope from "@/constants/Scope";

const settings = {
    categoryName: "export",
    scope: scope,
  } as const;

  export default settings;